import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-crop-image',
  templateUrl: './crop-image.component.html',
  styleUrls: ['./crop-image.component.scss']
})
export class CropImageComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CropImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  imageFile: any = '';

  croppedImage: any = '';
  
  canvasRotation = 0;

  rotation = 0;

  scale = 1;

  showCropper = false;

  containWithinAspectRatio = false;

  transform: ImageTransform = {};

  ngOnInit() {

    this.imageFile = this.data.imageFile;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event;
  
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
  }

  loadImageFailed() {
    
  }

  onDone(){
    this.dialogRef.close({ 'croppedImage' : this.croppedImage, 'name': this.imageFile.name});
  }
}
